// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3x55z","buttons":"PendingPaymentAlert_buttons__3RLY6"};